import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import axios from "axios";
import { RepositoryFactory } from "repositroy/RepositoryFactory";

export const getSchoolRequests =
  (lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let quary = await firebase
      .firestore()
      .collection("users")
      .where("role", "==", "school-admin")
      .where("type", "==", "school platform")
      .where("status", "==", "pending")
      .orderBy("created_at")
      .limit(5);
    if (lastDocument) {
      quary = quary.startAfter(lastDocument);
    }
    quary.get().then(async (query) => {
      let temp_data = [];
      for await (let doc of query.docs) {
        temp_data.push({ ...doc.data(), id: doc.id });
      }

      dispatch({
        type: lastDocument ? "MORE_GET_SCHOOL_REQUESTS" : "GET_SCHOOL_REQUESTS",
        payload: {
          data: temp_data,
          hasMore: temp_data.length == 5,
          lastDocument:
            query.docs.length > 0 ? query.docs[query.docs.length - 1] : null,
        },
      });
      onComplete();
    });
  };
export const getCollectiveRequests =
  (lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let quary = await firebase
      .firestore()
      .collection("users")
      .where("role", "==", "school-admin")
      .where("type", "==", "collective")
      .where("status", "==", "pending")
      .orderBy("created_at")
      .limit(5);
    if (lastDocument) {
      quary = quary.startAfter(lastDocument);
    }
    quary.get().then(async (query) => {
      let temp_data = [];
      for await (let doc of query.docs) {
        temp_data.push({ ...doc.data(), id: doc.id });
      }

      dispatch({
        type: lastDocument
          ? "MORE_GET_COLLECTIVE_REQUESTS"
          : "GET_COLLECTIVE_REQUESTS",
        payload: {
          data: temp_data,
          hasMore: temp_data.length == 5,
          lastDocument:
            query.docs.length > 0 ? query.docs[query.docs.length - 1] : null,
        },
      });
      onComplete();
    });
  };

export const getApprovedSchools =
  (filter, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let quary = await firebase
      .firestore()
      .collection("users")
      .where("role", "==", "school-admin")
      .where("status", "==", "approved")
      .where("type", "==", "school platform")
      .orderBy("created_at")
      .limit(5);
    if (lastDocument) {
      quary = quary.startAfter(lastDocument);
    }
    if (filter.instituteLevel !== "") {
      quary = quary.where("instituteLevel", "==", filter.instituteLevel);
    }
    if (filter.state !== "") {
      quary = quary.where("state", "==", filter.state);
    }
    if (filter.city !== "") {
      quary = quary.where("county", "==", filter.city);
    }
    if (filter.school !== "") {
      quary = quary.where("instituteName", "==", filter.school);
    }
    if (filter.date !== "") {
      const date = new Date(filter.date);
      const startOfDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      const endOfDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
        999
      );
      const startTimestamp = firebase.firestore.Timestamp.fromDate(startOfDay);
      const endTimestamp = firebase.firestore.Timestamp.fromDate(endOfDay);
      quary = quary
        .where("created_at", ">=", startTimestamp)
        .where("created_at", "<=", endTimestamp);
    }
    if (filter.adminName !== "") {
      quary = quary.where("name", "==", filter.adminName);
    }
    if (filter.adminEmail !== "") {
      quary = quary.where("email", "==", filter.adminEmail);
    }
    quary.get().then(async (query) => {
      let temp_data = [];
      let school_emails = [];
      for await (let doc of query.docs) {
        temp_data.push({ ...doc.data(), id: doc.id });
        school_emails.push(doc.data().email);
      }
      dispatch({
        type: lastDocument ? "MORE_GET_APPROVED_SCHOOL" : "GET_APPROVED_SCHOOL",
        payload: {
          data: temp_data,
          schoolEmails: school_emails,
          hasMore: temp_data.length == 5,
          lastDocument:
            query.docs.length > 0 ? query.docs[query.docs.length - 1] : null,
        },
      });
      onComplete();
    });
  };
export const getApprovedCollectives =
  (filter, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let quary = await firebase
      .firestore()
      .collection("users")
      .where("role", "==", "school-admin")
      .where("status", "==", "approved")
      .where("type", "==", "collective")
      .orderBy("created_at")
      .limit(5);
    if (lastDocument) {
      quary = quary.startAfter(lastDocument);
    }
    if (filter.instituteLevel !== "") {
      quary = quary.where("instituteLevel", "==", filter.instituteLevel);
    }
    if (filter.state !== "") {
      quary = quary.where("state", "==", filter.state);
    }
    if (filter.city !== "") {
      quary = quary.where("county", "==", filter.city);
    }
    if (filter.school !== "") {
      quary = quary.where("instituteName", "==", filter.school);
    }
    if (filter.date !== "") {
      const date = new Date(filter.date);
      const startOfDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      const endOfDay = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
        999
      );
      const startTimestamp = firebase.firestore.Timestamp.fromDate(startOfDay);
      const endTimestamp = firebase.firestore.Timestamp.fromDate(endOfDay);
      quary = quary
        .where("created_at", ">=", startTimestamp)
        .where("created_at", "<=", endTimestamp);
    }
    if (filter.adminName !== "") {
      quary = quary.where("name", "==", filter.adminName);
    }
    if (filter.adminEmail !== "") {
      quary = quary.where("email", "==", filter.adminEmail);
    }
    quary.get().then(async (query) => {
      let temp_data = [];
      for await (let doc of query.docs) {
        temp_data.push({ ...doc.data(), id: doc.id });
      }
      dispatch({
        type: lastDocument
          ? "MORE_GET_APPROVED_COLLECTIVE"
          : "GET_APPROVED_COLLECTIVE",
        payload: {
          data: temp_data,
          hasMore: temp_data.length == 5,
          lastDocument:
            query.docs.length > 0 ? query.docs[query.docs.length - 1] : null,
        },
      });
      onComplete();
    });
  };

export const acceptSchoolRequest =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase.firestore().collection("users").doc(id).update({
      status: "approved",
    });
    dispatch({
      type: "REMOVE_SCHOOL",
      payload: id,
    });
    onComplete();
  };
export const rejectSchoolRequest =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase.firestore().collection("users").doc(id).delete();
    dispatch({
      type: "REMOVE_SCHOOL",
      payload: id,
    });
    onComplete();
  };

export const getChangeAdminRequests =
  (lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let quary = await firebase
      .firestore()
      .collection("change_school_admin_requests")
      .where("status", "==", "fhp admin pending")
      .where("type", "==", "school platform")
      .orderBy("created_at")
      .limit(5);
    if (lastDocument) {
      quary = quary.startAfter(lastDocument);
    }
    quary.get().then(async (query) => {
      let temp_data = [];
      for await (let doc of query.docs) {
        let nowAdmin = await firebase
          .firestore()
          .collection("users")
          .doc(doc.data().schoolAdminId)
          .get();
        temp_data.push({
          ...doc.data(),
          id: doc.id,
          nowAdmin: nowAdmin.data(),
        });
      }
      dispatch({
        type: lastDocument
          ? "MORE_GET_CHANGE_ADMIN_REQUEST"
          : "GET_CHANGE_ADMIN_REQUEST",
        payload: {
          data: temp_data,
          hasMore: temp_data.length == 5,
          lastDocument:
            query.docs.length > 0 ? query.docs[query.docs.length - 1] : null,
        },
      });
      onComplete();
    });
  };
export const getChangeCollectiveAdminRequests =
  (lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let quary = await firebase
      .firestore()
      .collection("change_school_admin_requests")
      .where("status", "==", "fhp admin pending")
      .where("type", "==", "collective")
      .orderBy("created_at")
      .limit(5);
    if (lastDocument) {
      quary = quary.startAfter(lastDocument);
    }
    quary.get().then(async (query) => {
      let temp_data = [];
      for await (let doc of query.docs) {
        let nowAdmin = await firebase
          .firestore()
          .collection("users")
          .doc(doc.data().schoolAdminId)
          .get();
        temp_data.push({
          ...doc.data(),
          id: doc.id,
          nowAdmin: nowAdmin.data(),
        });
      }
      dispatch({
        type: lastDocument
          ? "MORE_GET_CHANGE_COLLECTIVE_ADMIN_REQUEST"
          : "GET_CHANGE_COLLECTIVE_ADMIN_REQUEST",
        payload: {
          data: temp_data,
          hasMore: temp_data.length == 5,
          lastDocument:
            query.docs.length > 0 ? query.docs[query.docs.length - 1] : null,
        },
      });
      onComplete();
    });
  };
export const rejectAdminRequests =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("change_school_admin_requests")
      .doc(id)
      .delete();
    dispatch({
      type: "REMOVE_CHANGE_ADMIN_REQUEST",
      payload: id,
    });
    onComplete();
  };

export const acceptAdminRequests =
  (obj, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("users")
      .doc(obj.schoolAdminId)
      .update({
        email: obj.email,
        name: obj.name,
      });
    await firebase
      .firestore()
      .collection("schoolContracts")
      .where("email", "==", obj.currentEmail)
      .get()
      .then(async (query) => {
        if (!query.empty) {
          await firebase
            .firestore()
            .collection("schoolContracts")
            .doc(query.docs[0].id)
            .update({
              email: obj.email,
            });
        }
      });
    await firebase
      .firestore()
      .collection("change_school_admin_requests")
      .doc(obj.id)
      .delete();
    dispatch({
      type: "REMOVE_CHANGE_ADMIN_REQUEST",
      payload: obj.id,
    });
    onComplete();
  };

export const fetchStates = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("states")
    .orderBy("name", "asc")
    .get()
    .then((query) => {
      var tempStates = [];
      query.forEach((doc) => {
        tempStates.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_COLLEGE_STATES",
        payload: tempStates,
      });
    });
};
export const fetchSchoolStates = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("school_states")
    .orderBy("name", "asc")
    .get()
    .then((query) => {
      var tempStates = [];
      query.forEach((doc) => {
        tempStates.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_SCHOOL_STATES",
        payload: tempStates,
      });
    });
};

export const getCollegeCity = (state) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test-colleges-universities")
    .where("state", "==", state)
    .orderBy("city", "asc")
    .get()
    .then((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "GET_CITY_BY_STATE", payload: temp });
    });
};

export const getSchoolCounty = (state) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test_schools")
    .where("state", "==", state)
    .orderBy("county", "asc")
    .get()
    .then((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "GET_COUNTY_BY_STATE", payload: temp });
    });
};

export const newSchoolsData = (state, college) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test_schools")
    .where("state", "==", state)
    .where("county", "==", college)
    .get()
    .then((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "NEW_SCHOOLS", payload: temp });
    });
};

export const newCollegeUniversities = (state, college) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test-colleges-universities")
    .where("state", "==", state)
    .where("city", "==", college)
    .get()
    .then((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "NEW_COLLEGE_UNIVERSITIES", payload: temp });
    });
};

export const getSchoolSubAdmins =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("school_admin_id", "==", id)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          temp_data.push({ ...doc.data(), id: doc.id });
        }
        dispatch({
          type: "SCHOOL_SUB_ADMINS",
          payload: temp_data,
        });
        onComplete();
      });
  };

export const updateAdsPermissions =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    let { id, oldAdsImg, type, adImg, ...newData } = data;
    try {
      if (adImg.name) {
        if (oldAdsImg) {
          await firebase.storage().refFromURL(oldAdsImg).delete();
        }
        const storageRef = firebase.storage().ref();
        const imageRef = await storageRef.child(
          `athleteBlogImages/${adImg.name}`
        );
        imageRef
          .put(adImg)
          .then((snapshot) => {
            return snapshot.ref.getDownloadURL();
          })
          .then((url) => {
            const newUpdatedData = {
              ...newData,
              adImg: url,
            };
            firebase
              .firestore()
              .collection("users")
              .doc(id)
              .update(newUpdatedData)
              .then(() => {
                dispatch({
                  type:
                    type == "school platform"
                      ? "UPDATE_SCHOOL_ADS_PERMISSION"
                      : "UPDATE_COLLECTIVE_ADS_PERMISSION",
                  payload: { id, data: newUpdatedData },
                });
                onComplete("success");
                toast.success("Update Ads Permissions");
              });
          });
      } else {
        const newUpdatedData = {
          ...newData,
          adImg: adImg,
        };
        firebase
          .firestore()
          .collection("users")
          .doc(id)
          .update(newUpdatedData)
          .then(() => {
            toast.success("Update Ads Permissions");
            dispatch({
              type:
                type == "school platform"
                  ? "UPDATE_SCHOOL_ADS_PERMISSION"
                  : "UPDATE_COLLECTIVE_ADS_PERMISSION",
              payload: { id, data: newUpdatedData },
            });
            onComplete("success");
          });
      }
    } catch (error) {
      console.error("Error updating blog:", error);
      onComplete();
    }
  };

export const adminSendEmailSchool =
  (data, onComplete = () => {}) =>
  async () => {
    try {
      const emailPromises = data.emails.map((email) => {
        const options = {
          to: email,
          subject: "Admin Contact",
          text: data.text,
        };
        return axios.post(
          `${process.env.REACT_APP_FIREBASE_BASE_DOMAIN}/sendUserEmail`,
          options
        );
      });

      await Promise.all(emailPromises);
      toast.success(
        `Email${data.emails.length > 1 ? "s" : ""} Send successfully`
      );
      onComplete("success");
    } catch (error) {
      onComplete();
      toast.error("Failed to send emails. Please try again.");
    }
  };

export const GetUnRegisteredColleges =
  (data, onComplete = () => {}) =>
  (dispatch) => {
    const unRegisteredColleges = RepositoryFactory.get("unRegisterColleges");
    unRegisteredColleges
      .getUnRegistersColleges(data)
      .then((response) => {
        dispatch({
          type: data.lastDocId
            ? "MORE_GET_UN_REGISTERED_COLLEGES"
            : "GET_UN_REGISTERED_COLLEGES",
          payload: response.data,
        });
        onComplete();
      })
      .catch((error) => {
      });
  };
export const GetUnRegisteredSchools =
  (data, onComplete = () => {}) =>
  (dispatch) => {
    const unRegisteredSchools = RepositoryFactory.get("unRegisterSchools");
    unRegisteredSchools
      .getUnRegistersSchools(data)
      .then((response) => {
        dispatch({
          type: data.lastDocId
            ? "MORE_GET_UN_REGISTERED_SCHOOLS"
            : "GET_UN_REGISTERED_SCHOOLS",
          payload: response.data,
        });
        onComplete();
      })
      .catch((error) => {
      });
  };
